module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/stage-2-51167f83c0e7e3cd08cab5720b2b5d10.png";